export default __webpack_public_path__ + "static/media/homestay_mail2.f4c96d36.svg";